import { inject, Injectable } from '@angular/core';
import { BaseFilterCompanySegment } from '@clean-code/models';
import { ConfigService } from '@clean-code/shared/util-config';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BaseFilterService {
  private graphqlService = inject(GraphqlService);
  private configService = inject(ConfigService);

  public get$(): Observable<BaseFilterCompanySegment[]> {
    const query = `
      query GetCompanyType {
          companyTypesGetAll {
            id
            name
            option
          }
        }
    `;
    return this.graphqlService.query<BaseFilterCompanySegment[]>(
      query,
    );
  }

  public hknTypes$(): Observable<BaseFilterHknType[]> {
    const query = `
      query GetHknTypes {
          hknTypeGetAll(take: 100, order: { name: ASC }) {
            items {
              id
              name
            }
          }
        }
    `;
    return this.graphqlService
      .query<{ items: BaseFilterHknType[] }>(query)
      .pipe(map((data) => data?.items ?? []));
  }
}

export interface BaseFilterHknType {
  id: number;
  name: string;
}
